import { AppBar, styled, Toolbar } from '@mui/material';
import React, { forwardRef } from 'react';

interface MobileNavbarContainerProps {
  topHeaderchildren: React.ReactNode;
  bottomHeaderChildren: React.ReactNode;
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const StyledToolBar = styled(Toolbar)(() => ({
  justifyContent: 'space-between',
}));

export const MobileNavbarContainer = forwardRef<HTMLDivElement, MobileNavbarContainerProps>(
  ({ topHeaderchildren, bottomHeaderChildren }, ref) => (
    <StyledAppBar position="static" ref={ref} aria-label="Application Header">
      <StyledToolBar disableGutters variant="dense">
        {topHeaderchildren}
      </StyledToolBar>
      <StyledToolBar disableGutters>{bottomHeaderChildren}</StyledToolBar>
    </StyledAppBar>
  ),
);
